const PIXEL_ID = '1154323073507518'

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  const w = window as any
  if (w.fbq) return

  const fbq: any = function (...args: any[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue.push(args)
    }
  }

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as any[]

  w.fbq = fbq
  w._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')

  // noscript fallback pixel
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(img)
}

export function trackAddToCart() {
  const w = window as any
  if (typeof w.fbq === 'function') {
    w.fbq('track', 'AddToCart', {
      content_name: 'Kit Gato Zen',
      content_type: 'product',
      value: 9499,
      currency: 'ARS',
    })
  }
}
